// Keyword-rich internal links for SEO + AI search discovery (footer cluster).
export const seoLinks = [
    { label: "Brand Consultant Bangalore", to: "/brand-consultant-bangalore" },
    { label: "Business Growth Consultant Bangalore", to: "/business-growth-consultant-bangalore" },
    { label: "Brand Strategy Consultant", to: "/brand-consultant-bangalore" },
    { label: "Business Diagnostic Report Online", to: "/consultation" },
    { label: "Business Analysis Report Online", to: "/consultation" },
    { label: "Website Audit Service", to: "/website-audit" },
    { label: "Brand Audit Service", to: "/brand-analysis" },
    { label: "Social Media Audit", to: "/social-media-strategy" },
    { label: "Competitor Analysis Report", to: "/consultation" },
    { label: "Customer Journey Review", to: "/consultation" },
    { label: "Growth Roadmap Consultation", to: "/consultation" },
    { label: "Business Growth Roadmap Plan", to: "/consultation" },
    { label: "Marketing Consultant Bengaluru", to: "/consultation" },
    { label: "Startup Mentor India", to: "/about" },
    { label: "MSME Branding Consultant Karnataka", to: "/msme-branding-consultant" },
    { label: "Digital Growth Consultant", to: "/consultation" },
    { label: "Brand Positioning Expert", to: "/consultation" },
    { label: "Personal Branding Consultant", to: "/consultation" },
    { label: "Lead Generation Strategy", to: "/consultation" },
    { label: "Business Growth Workshop for Teams", to: "/workshops" },
    { label: "Online Business Consultant India", to: "/" },
    { label: "Logo Design Consultant Bangalore", to: "/logo-design-consultant" },
    { label: "Packaging Design Case Study", to: "/case-studies" },
    { label: "Website Design Case Study", to: "/case-studies" },
    { label: "Visual Designer Bangalore", to: "/visual-designer-bangalore" },
    { label: "Social Media Growth", to: "/case-studies" },
    { label: "Brand Storytelling Consultant", to: "/brand-storytelling-consultant" },
    { label: "Ragi Media Founder", to: "/about" },
    { label: "Abhijit JK Consultant", to: "/about" },
    { label: "Business Strategy Blog", to: "/blog" },
    { label: "Branding Tips for Founders", to: "/blog" },
    { label: "How to Grow a Small Business", to: "/blog" },
    { label: "Local Business to National Brand", to: "/consultation" },
    { label: "Restaurant Branding Consultant", to: "/consultation" },
    { label: "D2C Brand Growth", to: "/consultation" },
    { label: "Real Estate Marketing Consultant", to: "/consultation" },
    { label: "Clinic & Healthcare Branding", to: "/consultation" },
    { label: "Get a Business Review Report", to: "/consultation" },
    { label: "Book a Strategy Call", to: "/consultation" },
    { label: "Contact a Business Consultant", to: "/contact" },
];
